
export const PROMPTS = {
  PROPOSAL_DRAFT: (title: string, section: string, ctx: string, tone: string) => 
    `Role: Commercial Construction Estimator. 
     Task: Draft "${section}" for the project "${title}". Context: ${ctx}. 
     Focus on: Resource efficiency, private-sector deliverables, and protecting the contractor's fee margin.`,

  COMPREHENSIVE_REPORT: (title: string, status: string, metrics: string, risks: string, instr: string) => 
    `Executive Brief for Job "${title}". 
     Operational Performance: ${metrics}. Field Hurdles: ${risks}. 
     Target Audience: Construction Firm Owners. Focus on Profitability and Schedule health. Output JSON only.`,

  INTELLIGENCE_SCAN: `Act as a Commercial Construction Auditor. Analyze this document for:
     1. SCOPE GAPS: Potential items not in the bid but required for the build.
     2. CONTRACTUAL DEADLINES: Payment application dates, RFI turnaround times, and milestone penalties.
     3. TRADE TASKS: Extract high-level tasks for subcontractors.
     Focus on protecting the Contractor's margin and schedule.`,

  SCOPE_AUDIT: (projectTitle: string, wbsItems: string, newObservation: string) =>
    `Role: Senior Commercial Project Manager.
     Job: "${projectTitle}".
     Current Approved WBS: ${wbsItems}.
     Field Observation/New Requirement: "${newObservation}".
     
     Task: Audit for Scope Gaps.
     1. Is this observation covered by the current WBS?
     2. If not, quantify the potential cost impact (Low/Med/High).
     3. Provide a 1-sentence technical justification for a Change Order.
     Output as JSON.`,

  BUDGET_FORECAST: (title: string, budget: number, history: string, items: string) => 
    `Role: Senior Commercial Cost Controller.
     Job: "${title}" (Contract: $${budget}).
     Performance History: ${history}.
     Budget Breakout: ${items}.
     
     Task: Forecast the Margin.
     1. Predict the final profit margin based on current burn rate.
     2. Identify which trades are causing cost overruns.
     3. Provide 3 direct actions to stop budget bleed.
     Output must be JSON.`,

  REFINE_MITIGATION: (projectTitle: string, riskSummary: string, currentPlan: string) =>
    `Role: Field Operations Manager.
     Job: "${projectTitle}".
     Operational Issue: "${riskSummary}".
     Proposed Fix: "${currentPlan}".
     
     Task: Refine this into a field-ready directive. 
     Focus on: Keeping the job moving, minimizing cost impact, and coordination with subcontractors. Maximum 80 words.`,

  RESOLVE_ISSUE: (projectTitle: string, issueDesc: string, priority: string) =>
    `Role: Senior Project Manager.
     Job: "${projectTitle}".
     Field Issue: "${issueDesc}".
     Priority: ${priority}.
     
     Task: Provide a concrete field directive to resolve this within 48 hours. Focus on contractor-side resource allocation.`,

  AUDIT_CHANGE_ORDER: (title: string, amount: number, desc: string, logs: string) =>
    `Role: Commercial Contract Administrator.
     Change Order: "${title}" ($${amount}).
     Description: "${desc}".
     Notes: "${logs}".
     
     Task: Generate a defensible "Client Justification" for this change order.
     Instructions:
     1. Highlight why this is outside the original contract scope.
     2. Justify the cost based on market rates.
     3. Keep it professional but firm to ensure payment. Maximum 100 words.`
};
